import { useEffect, useState } from "react"

interface DataFreshness {
  isStale: boolean
  lastUpdated: string | null
  thresholdHours: number
}

export function DataFreshnessWarning() {
  const [freshness, setFreshness] = useState<DataFreshness | null>(null)

  useEffect(() => {
    let cancelled = false
    fetch(`${import.meta.env.VITE_API_BASE_URL || ""}/chatbot/data-freshness`, {
      credentials: "include",
    })
      .then(res => res.json())
      .then(data => {
        if (!cancelled && data) setFreshness(data)
      })
      .catch(() => {
        /* ignore */
      })
    return () => {
      cancelled = true
    }
  }, [])

  if (!freshness?.isStale) return null

  const lastUpdatedStr = freshness.lastUpdated
    ? new Date(freshness.lastUpdated).toLocaleString()
    : "unknown"

  return (
    <div className="flex items-center gap-2 px-4 py-1.5">
      <span className="w-1.5 h-1.5 rounded-full bg-warning shrink-0" />
      <span className="text-xs text-warning">
        Data may be stale. Last updated: {lastUpdatedStr}
      </span>
    </div>
  )
}
